export default "__VITE_ASSET__RqlZ0jk1__"